import AnalyticsHandlers from './analytics-handlers';
import ProfileHandlers from './profile-handlers';
import DropdownSelectionHandlers from './dropdown-selection-handlers';
import ResultsHandlers from './main-page-handlers';
import InstructionalAreasHandlers from './instructional-areas-handlers';
import BatchPrintHandlers from './batch-print-handlers';

export default [
    ...ProfileHandlers,
    ...DropdownSelectionHandlers,
    ...AnalyticsHandlers,
    ...ResultsHandlers,
    ...InstructionalAreasHandlers,
    ...BatchPrintHandlers,
];
